<div class="">
  <div class="">
    <div class="content">
      <div *ngIf="!loggedIn; else userInfo">
        <app-login></app-login>
      </div>
      <ng-template #userInfo>
      </ng-template>
    </div>
  </div>
</div>
